export enum VideoStatus {
  Connecting = 'connecting',
  Connected = 'connected',
  Playing = 'playing',
  Disconnected = 'disconnected',
}
